<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{ title }}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form *ngIf="selectItems || selectGroups; else noData" [formGroup]="compareForm" (ngSubmit)="onGetReport()">
            <ng-container formArrayName="selectList">
                <mat-form-field *ngFor="let control of selectList.controls; let i = index">
                    <mat-label>{{ 'reports.compare.select.shortLabel' | translate }} {{ i + 1 }}</mat-label>
                    <mat-select [formControlName]="i">
                        <mat-option> - </mat-option>
                        <ng-container *ngIf="selectItems">
                            <mat-option *ngFor="let item of selectItems" [value]="item.code">
                                {{ item.text.shortLabel }}
                            </mat-option>
                        </ng-container>

                        <ng-container *ngIf="selectGroups">
                            <mat-optgroup *ngFor="let group of selectGroups" [label]="group.label">
                                <mat-option *ngFor="let item of group.items" [value]="item.code">
                                    {{ item.text.shortLabel }}
                                </mat-option>
                            </mat-optgroup>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </ng-container>
            <ng-container>
                <mat-form-field *ngIf="years">
                    <mat-label>{{ 'reports.compare.years.shortLabel' | translate }}</mat-label>
                    <mat-select [(value)]="selectedYear">
                        <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>

            <button *ngIf="!isLoading; else loader" mat-raised-button color="accent" type="submit" [disabled]="!isComplete">
                {{ 'reports.compare.title.shortLabel' | translate }}
            </button>
            <ng-template #loader>
                <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
            </ng-template>
        </form>
        <ng-template #noData>
            <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
        </ng-template>
    </mat-card-content>
    <mat-card-actions *ngIf="paramLink">
        <a mat-button [routerLink]="paramLink.route">
            <mat-icon aria-label="Settings">{{ paramLink.icon }}</mat-icon>
            {{ paramLink.title | translate }}
        </a>
    </mat-card-actions>
</mat-card>
